import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchGSTDetailsAPI,
  submitUserRegistrationDetailsAPI,
  userRegistrationAPI,
  aadharRegister
} from "../service/apiEndPoints";

export const aadharRegisterThunk = createAsyncThunk(
  "register/editregister",
  async () => {
    try {
      const response = await aadharRegister(); 
      return response?.data;
    } catch (error: any) {
      return error;
    }
  }
);

export const userRegistrationThunk = createAsyncThunk(
  "register/editregister",
  async (payload: any) => {
    try {
      const response = await userRegistrationAPI(payload); 
      return response?.data?.data;
    } catch (error: any) {
      return error;
    }
  }
);

export const fetchGSTDetailsThunk = createAsyncThunk(
  "register/fetchGSTDetails",
  async (payload: any) => {
    try {
      const response = await fetchGSTDetailsAPI(payload); 
      return response?.data?.data;
    } catch (error: any) {
      return error;
    }
  }
);

export const submitUserRegistrationDetailsThunk = createAsyncThunk(
  "register/submitUserDetails",
  async (payload: any) => {
    try {
      const response = await submitUserRegistrationDetailsAPI(payload); 
      return response?.data?.data;
    } catch (error: any) {
      return error;
    }
  }
);
